import { store, getContext, getElement } from '@wordpress/interactivity';
import GLightbox from 'glightbox';
import Swiper from 'swiper/bundle';
import 'swiper/css';

// Fonction d'initialisation directe
function initializeSlider() {
    const sliders = document.querySelectorAll('.gt-ws-ctv-is-slider');
    
    sliders.forEach(slider => {
        if (slider.swiperInitialized) {
            return; // Déjà initialisé
        }
    
        
        const wrapper = slider.querySelector('.swiper-wrapper');
        const slides = wrapper ? wrapper.querySelectorAll('.swiper-slide') : [];
        
        // Vérifier s'il y a des images dans les slides
        const hasImages = Array.from(slides).some(slide => {
            const img = slide.querySelector('img');
            return img && img.src && img.src !== '';
        });
        
        if (slides.length === 0) {
            console.warn('No slides found in slider');
            return;
        }
        
        if (!hasImages) {
            console.warn('No images found in slider slides, skipping Swiper initialization');
            return;
        }
        
        // Nettoyer les éléments existants
        const existingNext = slider.querySelector('.swiper-button-next');
        const existingPrev = slider.querySelector('.swiper-button-prev');
        const existingPagination = slider.querySelector('.swiper-pagination');
        
        if (existingNext) existingNext.remove();
        if (existingPrev) existingPrev.remove();
        if (existingPagination) existingPagination.remove();
        
        // Créer les éléments de navigation
        const paginationWrapper = document.createElement('div');
        paginationWrapper.classList.add('swiper-pagination');
        slider.appendChild(paginationWrapper);
        
        const buttonNextWrapper = document.createElement('div');
        buttonNextWrapper.classList.add('swiper-button-next');
        slider.appendChild(buttonNextWrapper);
        
        const buttonPrevWrapper = document.createElement('div');
        buttonPrevWrapper.classList.add('swiper-button-prev');
        slider.appendChild(buttonPrevWrapper);
        
        // Configuration par défaut
        const defaultConfig = {
            speed: 400,
            spaceBetween: 16,
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: buttonNextWrapper,
                prevEl: buttonPrevWrapper,
            },
            pagination: {
                el: paginationWrapper,
                dynamicBullets: true,
                clickable: true
            }
        };
        
        // Récupérer la config depuis data-swiper
        let jsonConfig = {};
        try {
            const dataSwiper = slider.getAttribute('data-swiper');
            if (dataSwiper) {
                jsonConfig = JSON.parse(dataSwiper);
            }
        } catch (e) {
            console.warn('Error parsing data-swiper:', e);
        }
        
        // Construire la configuration finale
        let finalConfig = { ...defaultConfig, ...jsonConfig };
        
        // Gérer la navigation désactivée
        if (jsonConfig.navigation === false) {
            finalConfig.navigation = false;
            // Supprimer les boutons de navigation
            if (buttonNextWrapper) buttonNextWrapper.remove();
            if (buttonPrevWrapper) buttonPrevWrapper.remove();
        }
        
        // Gérer la pagination désactivée
        if (jsonConfig.pagination === false) {
            finalConfig.pagination = false;
            if (paginationWrapper) paginationWrapper.remove();
        }
        
        // Gérer l'effet fade
        if (jsonConfig.effect && jsonConfig.effect.fade) {
            finalConfig.effect = 'fade';
            finalConfig.fadeEffect = {
                crossFade: true
            };
        }
        
        
        try {
            const swiperInstance = new Swiper(slider, finalConfig);
            slider.swiperInstance = swiperInstance;
            slider.swiperInitialized = true;
            
            
            // Test de navigation
            setTimeout(() => {
                swiperInstance.slideNext();
                setTimeout(() => {
                    swiperInstance.slidePrev();
                }, 1000);
            }, 1000);
            
        } catch (error) {
            console.error('Error initializing slider:', error);
        }
    });
}

// Initialiser au chargement du DOM
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSlider);
} else {
    initializeSlider();
}

// Réinitialiser quand le contenu change (pour les pages SPA)
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1 && node.querySelector && node.querySelector('.gt-ws-ctv-is-slider')) {
                    setTimeout(initializeSlider, 100);
                }
            });
        }
    });
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

const { state } = store('gt/ctv/camping/image', {
    actions: {
        setImages: () => {
            const element = getElement();
            const context = getContext();
            const image = element.ref;

            if (!image || !image.getAttribute('data-gt-src')) {
                return;
            }

            if (image.dataset.gtLoaded === '1') {
                return;
            }

            const loadImage = () => {
                image.setAttribute('src', image.getAttribute('data-gt-src'));
                image.setAttribute('srcset', image.getAttribute('data-gt-srcset') || '');

                const sizes = image.getAttribute('data-gt-sizes');
                if (sizes) {
                    image.setAttribute('sizes', sizes);
                }

                if (context.ratio) {
                    image.style.aspectRatio = context.ratio;
                }

                image.dataset.gtLoaded = '1';
            };

            // Le slide actif doit se charger immédiatement (mobile + Swiper transform)
            if (image.closest('.swiper-slide-active')) {
                loadImage();
                return;
            }

            if (!('IntersectionObserver' in window)) {
                loadImage();
                return;
            }

            const observer = new IntersectionObserver((entries, obs) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        loadImage();
                        obs.unobserve(image);
                    }
                });
            }, {
                rootMargin: '200px',
                threshold: 0.01
            });

            observer.observe(image);
        },   
        openLightbox: (e) => {
            e.preventDefault();
            const context = getContext();
            let images = [];

            context.images.forEach(url => {
                images.push({
                    'href': url,
                    'type': 'image',
                });
            });

            const image = e.target;
            const clickedIndex = image.getAttribute('src') ? context.images.findIndex(href => href === image.getAttribute('src')) : 0;

            const gallery = GLightbox({
                elements: images,
                loop: true,
                zoomable: true,
                draggable: true,
                preload: true,
                startAt: clickedIndex == -1 ? 0 : clickedIndex,
            });

            gallery.open();
        }
    },
    callbacks:{

        resetSwiper: () => {
            const context = getContext();
            const element = getElement();


            // Vérifier si le slider est activé
            if (!context.isSlider) {
                return;
            }

            const defaultConfig = {
                speed: 400,
                spaceBetween: 16,
                slidesPerView: 1,
                createElements: true,
                loop: true,
                freemode: false,
                pagination: {
                    el: '.swiper-pagination',
                    dynamicBullets: true,
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1
                    },
                    380: {
                        slidesPerView: 1
                    },
                    1024: {
                        slidesPerView: 1
                    }
                }
            };

            const jsonConfig = context.jsonConfig || {};

            const slider = element.ref;

            if(!slider){
                console.warn('Slider element not found');
                return;
            }

            // Détruire l'instance existante si elle existe
            if (slider.swiperInstance) {
                slider.swiperInstance.destroy(true, true);
                slider.swiperInstance = null;
            }
            
            if (slider.classList.contains('swiper-initialized')) {
                slider.classList.remove('swiper-initialized');
            }

            const newConfig = { ...defaultConfig, ...jsonConfig };
            
            // Trouver le wrapper (il devrait déjà exister)
            const wrapper = slider.querySelector('.swiper-wrapper');
            
            if (!wrapper) {
                console.warn('Swiper wrapper not found');
                return;
            }
            
            // Vérifier qu'on a des slides
            const slides = wrapper.querySelectorAll('.swiper-slide');
            
            if (slides.length === 0) {
                console.warn('No slides found');
                return;
            }
            
            // Vérifier s'il y a des images dans les slides
            const hasImages = Array.from(slides).some(slide => {
                const img = slide.querySelector('img');
                return img && img.src && img.src !== '';
            });
            
            if (!hasImages) {
                console.warn('No images found in slider slides, skipping Swiper initialization');
                return;
            }
            
            // Nettoyer les éléments existants
            const buttonNext = slider.querySelector('.swiper-button-next');
            const buttonPrev = slider.querySelector('.swiper-button-prev');
            const pagination = slider.querySelector('.swiper-pagination');
            
            if (buttonNext) buttonNext.remove();
            if (buttonPrev) buttonPrev.remove();
            if (pagination) pagination.remove();

            // Créer les éléments de navigation
            const paginationWrapper = document.createElement('div');
            paginationWrapper.classList.add('swiper-pagination');
            slider.appendChild(paginationWrapper);

            const buttonNextWrapper = document.createElement('div');
            buttonNextWrapper.classList.add('swiper-button-next');
            slider.appendChild(buttonNextWrapper);

            const buttonPrevWrapper = document.createElement('div');
            buttonPrevWrapper.classList.add('swiper-button-prev');
            slider.appendChild(buttonPrevWrapper);
            
            // Attendre un tick pour s'assurer que les éléments sont dans le DOM
            setTimeout(() => {
                try {
                   
                    const swiperInstance = new Swiper(slider, {
                        ...newConfig,
                        navigation: {
                            nextEl: buttonNextWrapper,
                            prevEl: buttonPrevWrapper,
                        },
                        pagination: {
                            el: paginationWrapper,
                            dynamicBullets: true,
                            clickable: true
                        },
                        on: {
                            init: function() {
                               
                                
                                // Tester la navigation programmatiquement
                                setTimeout(() => {
                                    this.slideNext();
                                    setTimeout(() => {
                                        this.slidePrev();
                                    }, 1000);
                                }, 1000);
                            },
                            error: function(error) {
                                console.error('Swiper initialization error:', error);
                            }
                        }
                    });
                    
                    // Stocker l'instance pour pouvoir la détruire plus tard
                    slider.swiperInstance = swiperInstance;
                } catch (error) {
                    console.error('Error creating Swiper instance:', error);
                }
            }, 10);
            

        },
        
    }
});

// Fonction pour cacher le bloc wp-block-columns top si l'image par défaut est présente
function hideTopColumnsIfDefaultImage() {
    const defaultImagePath = '/wp-content/uploads/2025/11/Logo-Grand-Est-3-1.svg';
    
    // Trouver tous les blocs wp-block-columns avec la classe "top"
    const topColumnsBlocks = document.querySelectorAll('.wp-block-columns.top');
    
    topColumnsBlocks.forEach(block => {
        // Chercher toutes les images dans ce bloc
        const images = block.querySelectorAll('img');
        
        // Vérifier si au moins une image contient le chemin par défaut
        const hasDefaultImage = Array.from(images).some(img => {
            const src = img.getAttribute('src') || '';
            return src.includes(defaultImagePath);
        });
        
        // Si l'image par défaut est trouvée, cacher le bloc
        if (hasDefaultImage) {
            block.style.display = 'none';
        }
    });
}

// Exécuter au chargement du DOM
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideTopColumnsIfDefaultImage);
} else {
    hideTopColumnsIfDefaultImage();
}

// Observer les changements dans le DOM pour les pages dynamiques
const hideColumnsObserver = new MutationObserver(() => {
    hideTopColumnsIfDefaultImage();
});

hideColumnsObserver.observe(document.body, {
    childList: true,
    subtree: true
});